import { User } from '../types/auth';
import Tracking from '../utils/tracking';
import Formatter from '../utils/formatter';

export const sendSignInAttempted = (): void => {
  Tracking.event('Sign in attempted');
};

export const sendSignInSucceeded = (user: User): void => {
  const { email, phone, phoneCc, name, createdAt, userType } = user;

  Tracking.event('Sign in succeeded', {
    created: createdAt,
    email,
    name,
    phone: phone && phoneCc ? Formatter.phone(phone, phoneCc) : '',
    type: userType === 'business' ? 'business' : 'consumer',
  });
};

export const sendSignInFailed = (errorMsg = ''): void => {
  Tracking.event('Sign in failed', {
    reason: errorMsg,
  });
};

export const sendLogout = (): void => {
  Tracking.event('Logout');
};

export const sendRegisterAttempted = (referralCode?: string): void => {
  Tracking.event('Register attempted', {
    referral_code: referralCode,
  });
};

export const sendRegisterSucceeded = (referralCode?: string): void => {
  Tracking.event('Register succeeded', {
    referral_code: referralCode,
  });
};

export const sendRegisterFailed = (errorMsg = '', referralCode?: string): void => {
  Tracking.event('Register failed', { referral_code: referralCode, reason: errorMsg });
};

export const sendSendResetLinkAttempted = (): void => {
  Tracking.event('Send reset link attempted');
};

export const sendSendResetLinkSucceeded = (): void => {
  Tracking.event('Send reset link succeeded');
};

export const sendSendResetLinkFailed = (): void => {
  Tracking.event('Send reset link failed');
};

export const sendTermsAndConditionsAccepted = (): void => {
  Tracking.event('Terms and conditions accepted');
};
